<template>
    <div>
        <v-select
            :value="value"
            @input="handleInput"
            :class="errors && errors.length ? 'hasError' : ''"
            outlined
            :error="errors && errors.length > 0"
            :menu-props="{bottom: true, offsetY: true}"
            :clearable="clearable"
            :hide-details="true"
            :items="options"
            :returnObject="returnObject"
            :item-text="itemText"
            :item-value="itemValue"
            :disabled="disabled || false"
            :label="required ? label + '*' : label">
            <template v-slot:append><v-icon class="error-icon" v-if="errors && errors.length">mdi-alert</v-icon></template>
            <template v-slot:item="{ item }">
                <v-list-item-content :data-testid="(item[itemValue] !== undefined ? String(item[itemValue]) : String(item ?? '')).toLowerCase() + 'DropdownOption'">
                    {{ item[itemText] !== undefined ? item[itemText] : item }}
                </v-list-item-content>
            </template>
        </v-select>
        <ErrorMessages :errors="errors"></ErrorMessages>
    </div>
</template>

<script>

export default {
    name: 'Dropdown',
    props: {
        value: [String, Number, Boolean, Object],
        rules: String,
        options: Array,
        label: String,
        clearable: Boolean,
        required: Boolean,
        errors: Array,
        disabled: Boolean,
        returnObject: {
            type: Boolean,
            default: false
        },
        itemText: {
            type: String,
            default: "text"
        },
        itemValue: {
            type: String,
            default: "value"
        },
        updateOptions: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'change'
    ],
    methods: {
        handleInput (val) {
            this.$emit('change', val);
        }
    },
    watch: {
        options: {
            immediate: true,
            handler (newOptions) {
                // if current value is not in the new options, but we have options, force value to first option
                if (this.updateOptions && this.value !== null && this.value !== undefined && newOptions && newOptions.length > 0) {
                    const valueInOptions = newOptions.some(opt => opt[this.itemValue] === this.value);
                    if (!valueInOptions) {
                        // value not in options - force to first option value
                        const firstOptionValue = newOptions[0][this.itemValue];
                        this.handleInput(firstOptionValue);
                    }
                }
            }
        }
    }
};

</script>
